var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("LayoutLeftAuth"),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-5 " }, [
          _c(
            "div",
            {
              staticClass:
                "container h-full d-flex align-items-center justify-content-center"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "row d-flex flex-column text-center align-items-center"
                },
                [
                  _c("img", {
                    staticClass: "logo-mobile-auth d-block d-sm-none",
                    attrs: { src: require("../../assets/img/blue-logo.png") }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "welcome-text" }, [
                    _vm._v("\n            Welcome back!\n          ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "under-welcome-text" }, [
                    _vm._v(
                      "\n            Login to your dispatch application\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "new-auth-form",
                      attrs: { autocomplete: "no" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.login($event)
                        },
                        keydown: function($event) {
                          _vm.clearError($event)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12 first-input" },
                          [
                            _c("div", { staticClass: "material-textfield" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.auth.email,
                                    expression: "auth.email"
                                  }
                                ],
                                attrs: {
                                  id: "email",
                                  name: "email",
                                  type: "text",
                                  placeholder: " ",
                                  autofocus: ""
                                },
                                domProps: { value: _vm.auth.email },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.auth,
                                      "email",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", [_vm._v("Email")])
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              staticClass: "material-errors",
                              attrs: { errors: _vm.errors, field: "email" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 second-input" },
                          [
                            _c("div", { staticClass: "material-textfield" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.auth.password,
                                    expression: "auth.password"
                                  }
                                ],
                                attrs: {
                                  id: "password",
                                  name: "password",
                                  type: "password",
                                  placeholder: " "
                                },
                                domProps: { value: _vm.auth.password },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.auth,
                                      "password",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", [_vm._v("Password")])
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              staticClass: "material-errors",
                              attrs: { errors: _vm.errors, field: "password" }
                            }),
                            _vm._v(" "),
                            _c("error-field", {
                              staticClass: "material-errors",
                              attrs: {
                                errors: _vm.errors,
                                field: "credentials"
                              }
                            }),
                            _vm._v(" "),
                            _c("error-field", {
                              staticClass: "material-errors",
                              attrs: { errors: _vm.errors, field: "exception" }
                            }),
                            _vm._v(" "),
                            _vm.userStatusError
                              ? _c("div", { staticClass: "material-errors" }, [
                                  _vm._v("Your account is inactive.")
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        staticClass:
                          "btn btn-primary login-button hover-btn-bg",
                        attrs: {
                          type: "submit",
                          value: "Login",
                          disabled: _vm.errors.any()
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "thick-font",
                      attrs: { to: "forgot-password" }
                    },
                    [_vm._v("Forgot password?")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "under-button-text" }, [
                    _vm._v("Don't have an account yet?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "sign-up-btn",
                      on: {
                        click: function($event) {
                          _vm.$router.push("/register")
                        }
                      }
                    },
                    [_vm._v(" Sign up")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    { attrs: { href: _vm.getForemanUrl, target: "_blank" } },
                    [_vm._m(0)]
                  )
                ],
                1
              )
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "foreman-retangle align-items-center d-md-none" },
      [
        _c(
          "span",
          {
            staticClass:
              "d-flex justify-content-between align-items-center foreman-top"
          },
          [
            _c("div", { staticClass: "foreman-title-respo" }, [
              _vm._v("Are you a foreman?")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "foreman-arrow-respo pointer" }, [
              _c("span", { staticClass: "thick-font changed-router-links" }, [
                _c("i", { staticClass: "fa fa-long-arrow-right" })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "foreman-text-respo" }, [
          _vm._v(
            "We’re currently working on a native app for Android and iOS. For now you can login to your account and track moves on our web app."
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bab3132", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bab3132","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Login.vue
// module id = null
// module chunks = 